<script>
    import { onMount, afterUpdate } from 'svelte';
    import { Chart } from 'chart.js/auto';

    export let headerTitle = '';
    export let chartData = { labels: [], datasets: [] };

    let chartCanvas;
    let chartInstance = null;

    onMount(() => {
        renderChart();
        return () => {
            if (chartInstance) {
                chartInstance.destroy();
                chartInstance = null;
            }
        };
    });

    afterUpdate(() => {
        if (chartData && chartCanvas) {
            renderChart();
        }
    });

    function renderChart() {
        if (chartInstance) {
            chartInstance.destroy();
        }
        if (!chartCanvas) return;

        chartInstance = new Chart(chartCanvas, {
            type: 'doughnut',
            data: chartData,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            boxWidth: 12,
                            padding: 20,
                            font: {
                                size: 11
                            }
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function(context) {
                                let label = context.label || '';
                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed !== null) {
                                    label += context.parsed + '%';
                                }
                                return label;
                            }
                        }
                    }
                },
                cutout: '60%',
            }
        });
    }
</script>

<div class="chart-container">
    {#if headerTitle}
        <div class="chart-header">
            <h4>{headerTitle}</h4>
        </div>
    {/if}
    <div class="chart-wrapper">
        <canvas bind:this={chartCanvas}></canvas>
    </div>
</div>

<style>
    .chart-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .chart-header {
        margin-bottom: 1rem;
    }
    .chart-header h4 {
        margin: 0;
        font-size: 1.1rem;
        font-weight: 500;
    }
    .chart-wrapper {
        position: relative;
        flex-grow: 1;
    }
</style>
